__webpack_require__.p = "https://assets.khanoumi.com/4.167.1.0/_next/";